import { TileRoleRoute } from '@/types'
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { ManagementGrid } from '@/routes/admin/components/ManagementGrid/ManagementGrid'
import { ManagementGridExtendedColumn } from '@/routes/admin/components/ManagementGrid/types'
import { DataGridTypes } from 'devextreme-react/data-grid'
import { createQueryBuilderV4 } from '@odata2ts/odata-query-builder'
import { qqs_supporto_applicazione, qqs_versione } from '@/model/qsadminapi/QQsAdminApiModule'
import { ReferencesV2 } from '@/routes/admin/components/ManagementGrid/ReferencesV2'
import { ColumnCellTemplateData } from 'devextreme/ui/data_grid'

const columns: ManagementGridExtendedColumn[] = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    allowEditing: false,
    width: 60,
  },
  {
    dataField: 'major',
    caption: 'Major',
    dataType: 'number',
    allowEditing: true,
    groupIndex: 0,
  },
  {
    dataField: 'minor',
    caption: 'Minor',
    dataType: 'number',
    allowEditing: true,
  },
  {
    dataField: 'sub',
    caption: 'Sub',
    dataType: 'number',
    allowEditing: true,
  },
  {
    dataField: 'note',
    caption: 'Note',
    dataType: 'string',
    allowEditing: true,
  },
  {
    caption: 'Licenze Collegate',
    dataType: 'object' as DataGridTypes.DataType,
    allowEditing: false,
    allowSorting: false,
    cellRender: (cell: ColumnCellTemplateData) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return React.useMemo(() => {
        if (!cell.data || cell.data.id === undefined) {
          return <span>No data available</span>
        }
        const builder = createQueryBuilderV4('qs_versione', qqs_versione)
        return (
          cell.data.id && (
            <ReferencesV2
              query={builder
                .select('licenze')
                .filter(qqs_supporto_applicazione.id.eq(cell.data.id))
                .expanding('licenze', (q) => q.select('id', 'chiave'))
                .build()}
              keyField={'id'}
              displayField={'chiave'}
              dataField={'licenze'}
              entityRoute={'software/qs'}
              maxCount={4}
            />
          )
        )
      }, [cell.data?.id])
    },
  },
  {
    caption: 'Versioni Spedite',
    dataType: 'object' as DataGridTypes.DataType,
    allowEditing: false,
    allowSorting: false,
    cellRender: (cell: ColumnCellTemplateData) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return React.useMemo(() => {
        if (!cell.data || cell.data.id === undefined) {
          return <span>No data available</span>
        }
        const builder = createQueryBuilderV4('qs_versione', qqs_versione)
        return (
          cell.data.id && (
            <ReferencesV2
              query={builder
                .select('versioni_spedite')
                .filter(qqs_supporto_applicazione.id.eq(cell.data.id))
                .expanding('versioni_spedite', (q) => q.select('id'))
                .build()}
              keyField={'id'}
              displayField={'id'}
              dataField={'versioni_spedite'}
              maxCount={4}
            />
          )
        )
      }, [cell.data?.id])
    },
  },
]

export const QSVersionRoute: TileRoleRoute = {
  path: 'qsversion',
  text: 'Versione QS',
  faIcon: faHistory,
  element: (
    <div className="content-block dx-card wide-card">
      <ManagementGrid
        endpoint={`${import.meta.env.VITE_QSADMINAPI_HOST}/qs_versione`}
        title={`Versioni QS`}
        columns={columns}
        expandRelations={[]}
        storageKey={`qs_versione-state-management-grid`}
        defaultPageSize={20}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      />
    </div>
  ),
  handle: {
    crumb: () => ({
      label: 'Versione QS',
      icon: faHistory,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
